import Duck from 'extensible-duck';
import Immutable from 'immutable';

export default new Duck({
  namespace: 'public',
  store: 'document',
  types: [],
  initialState: Immutable.fromJS({
    $$documents: [],
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      default:
        return $$state;
    }
  },
  selectors: {},
  creators: ({ types }) => ({}),
});
